<button (click)="topFunction()" id="myBtn" title="Go to top"></button> 